/**
 * Created by tofael on 7/13/17.
 */
import React from 'react';

import Admin from './admin';
import Doctor from './doctor';
import globalStyles from '../../utility/styles';
import ImageViewer from '../shared/image-viewer';
import ConfirmDialog from '../shared/confirmation-dialog';

const Profile = (props)=>{
 const {
   title, isDoctor, isAdmin, imageViewerOpen, imageUrl, closeImage, alertDialogOpen, alertText, handleConfirmDialogClose,
   getHandleConfirmFunction
 } = props;
 return (
   <div>
     <h1 style={globalStyles.header}>{title}</h1>
     {
       isDoctor &&
       <Doctor {...props}/>
     }
     {
       isAdmin &&
       <Admin {...props}/>
     }
     <ImageViewer
       onClose={closeImage}
       open={imageViewerOpen}
       imageUrl={imageUrl}/>
     <ConfirmDialog
       open={alertDialogOpen}
       alertText={alertText}
       handleOk={getHandleConfirmFunction}
       handleClose={handleConfirmDialogClose}/>
   </div>
 )
};

export default Profile;



// WEBPACK FOOTER //
// ./src/screens/profile/index.js